module.exports = __webpack_public_path__ + "img/INTERESTED.41f50985.png";